import { Route } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { UiKitComponent } from './pages/ui-kit/ui-kit.component';
import { environment } from 'src/environments/environment';
import { UserVacancyFormPage } from './features/users/pages/user-vacancy-form/user-vacancy-form.page';
import { IntroductionDocumentsComponent } from './pages/introduction-documents/introduction-documents.component';
import { AutoLoginGuard } from './core/guards/auto-login.guard';
import { createAuthShellRoute, LOGIN_V2_CHILDREN, REGISTRATION_CHILDREN, PVZ_CHILDREN } from './pages/login-v2/auth.routes';
import { AuthFlowId } from './pages/login-v2/config/auth-flow.constants';
import { redirectInvalidPvzLinkGuard } from './pages/login-v2/config/pvz-invalid-link.guard';
import { AuthShellPage } from './pages/login-v2/pages/auth-shell.page';

export const APP_ROUTES: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login',
  },
  {
    canMatch: [AuthGuard],
    loadChildren: () =>
      import('./pages/menu/menu.routes').then((m) => m.MENU_ROUTES),
    path: 'app',
  },
  ...(!environment.production
    ? [
        {
          path: 'ui-kit',
          component: UiKitComponent,
          title: `UI Kit | ${environment.appTitle}`,
        },
      ]
    : []),
  {
    component: UserVacancyFormPage,
    path: 'vacancy/:uuid',
    title: `Вакансия | ${environment.appTitle}`,
  },
  {
    canMatch: [AuthGuard],
    component: IntroductionDocumentsComponent,
    path: 'introduction',
    title: `Документы согласий | ${environment.appTitle}`,
  },
  {
    path: 'login/pvz',
    pathMatch: 'full',
    canActivate: [redirectInvalidPvzLinkGuard],
    component: AuthShellPage,
  },
  {
    path: 'pvz-link',
    pathMatch: 'full',
    canActivate: [redirectInvalidPvzLinkGuard],
    component: AuthShellPage,
  },
  {
    path: 'login/pvz/:uuid',
    pathMatch: 'full',
    redirectTo: 'pvz-link/:uuid',
  },
  {
    ...createAuthShellRoute('login', AuthFlowId.Login, LOGIN_V2_CHILDREN),
    canMatch: [AutoLoginGuard],
    title: `Вход в личный кабинет | ${environment.appTitle}`,
  },
  {
    ...createAuthShellRoute('registration', AuthFlowId.Registration, REGISTRATION_CHILDREN),
    canMatch: [AutoLoginGuard],
    title: `Регистрация | ${environment.appTitle}`,
  },
  {
    ...createAuthShellRoute('pvz-link/:uuid', AuthFlowId.Pvz, PVZ_CHILDREN),
    canMatch: [AutoLoginGuard],
    title: `Вход в личный кабинет | ${environment.appTitle}`,
  },
  {
    path: '**',
    redirectTo: '/login',
  },
];
